import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToHash = () => {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) return;

    let attempts = 0;
    const maxAttempts = 60;

    const tryScroll = () => {
      const container = document.getElementById("scroll-root");
      const target = document.getElementById(hash.replace("#", ""));

      if (container && target) {
        const y =
          target.getBoundingClientRect().top +
          container.scrollTop -
          container.getBoundingClientRect().top;

        container.scrollTo({
          top: y,
          behavior: "smooth",
        });
      } else if (attempts < maxAttempts) {
        attempts++;
        requestAnimationFrame(tryScroll);
      }
    };

    tryScroll();
  }, [hash, pathname]);

  return null;
};

export default ScrollToHash;
